import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import './Footer.css';

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer" id="contact">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-logo-section">
            <div className="footer-logo">
              <img src={`${process.env.PUBLIC_URL}/pharmacare-logo.png`} alt="Pharmacare Logo" className="footer-logo-image" />
              <span className="footer-logo-text">PHARMACARE</span>
            </div>
            <p className="footer-tagline">We care about your health</p>
          </div>

          <div className="footer-info">
            <div className="footer-column">
              <h4>Address</h4>
              <p>Pharmacare Pharmacies Private Limited</p>
              <p>P.O. Box 516</p>
              <p>Lilongwe</p>
              <p>MALAWI</p>
            </div>

            <div className="footer-column">
              <h4>Contact</h4>
              <p>
                <a href="tel:+265995165735">Retail: +265995165735</a>
              </p>
              <p>
                <a href="tel:+265881193314">Wholesale: +265881193314</a>
              </p>
              <p>
                <a href="mailto:info@pharmacaremw.com">info@pharmacaremw.com</a>
              </p>
            </div>

            <div className="footer-column">
              <h4>Quick Links</h4>
              <div className="quick-links">
                <Link to="/" onClick={scrollToTop}>Home</Link>
                <Link to="/branches" onClick={scrollToTop}>Branches</Link>
                <Link to="/products" onClick={scrollToTop}>Products</Link>
                <Link to="/delivery" onClick={scrollToTop}>Delivery</Link>
                <Link to="/about" onClick={scrollToTop}>About</Link>
              </div>
            </div>
            
            <div className="footer-column">
              <h4>Follow Us</h4>
              <div className="social-links">
                <a href="https://www.facebook.com/profile.php?id=100064278394536" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="facebook">
                  <FaFacebookF />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>Copyright © Pharmacare Pharmacies. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
